import React from 'react';
import Icon, { IconName } from '../../Icon';
import { View } from 'react-native';
import Stack from '../../Stack';
import Text from '../../Text';
import { getIntl } from '../../../../utils/intl';
import Button from '../../Button';
import { PRScrollView } from '../../../shared/Scroll';
import { colors } from '../../../../utils/theme';

const intl = getIntl('ActivityListSection', {
    seeAll: 'See All',
    add: 'Add',
});

export type ListSectionOwnProps = {
    children: React.ReactNode;
    title: string;
    icon: IconName;
    onPressSeeAll: () => void;
    noResultsMessage: string;
    showNoResultsMessage: boolean;
    seeAllTestId?: string;
    onAdd: () => void;
    addTestId?: string;
};

export const MAX_CARD_COUNT = 3;

export type ListSectionProps = ListSectionOwnProps;

const ListSection: React.FC<ListSectionProps> = (props) => {
    return (
        <View style={{ flex: 1, alignSelf: 'stretch' }}>
            <Stack
                horizontal
                style={{
                    alignSelf: 'stretch',
                    borderBottomWidth: 1,
                    borderBottomColor: colors['Dividers'],
                    marginBottom: 4,
                }}
                align="center"
                justify="space-between"
            >
                <Stack horizontal justify="flex-start" space={1} align="center">
                    <Icon name={props.icon} size="dashboard-list-icon" />
                    <Text variant="bold-body-1">{props.title}</Text>
                </Stack>
                <Button title={intl('add')} onPress={props.onAdd} variant="ghost" testID={props.addTestId} />
                <Button
                    variant="ghost"
                    title={intl('seeAll')}
                    onPress={props.onPressSeeAll}
                    testID={props.seeAllTestId}
                />
            </Stack>
            {props.showNoResultsMessage ? (
                <View style={{ flex: 1, alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center' }}>
                    <Text variant="bold-body-1" color="Grey-Light">
                        {props.noResultsMessage}
                    </Text>
                </View>
            ) : (
                <PRScrollView testID="section-list" style={{ flex: 1, alignSelf: 'stretch' }}>
                    {props.children}
                </PRScrollView>
            )}
        </View>
    );
};

export default React.memo(ListSection);
